// src/components/ContactUs.js
import React from "react";
import "../styles/ContactUs.css"; // Import the CSS file for styling

export default function ContactUs() {
  return (
    <div id="contactus">
      <footer className="footer-section bg-dark text-light py-5">
        <div className="container">
          {/* Locations Row */}
          <div className="row text-light">
            {/* Branch 1 */}
            <div className="col-md-4 mb-3 d-flex flex-column">
              <strong>Head Office:</strong>
              <p>
                Garhi Green Resident, Block - C, Garhi Harshru, Gurugram, Haryana, 122505
              </p>
            </div>
          </div>

          {/* Contact and Social Media Row */}
          <div className="row mt-4">
            {/* Contact Details */}
            <div className="col-md-6">
              <h4 className="mb-4">Contact Details</h4>
              <ul className="list-unstyled">
                <li>
                  <strong>Phone:</strong> +91-7779977726               </li>
                <li>
                  <strong>Email:</strong> customer-support@fashionflairworld.com
                </li>
              </ul>
            </div>
          </div>

          {/* Footer Bottom Section */}
          <div className="footer-bottom text-center mt-4 pt-4 border-top">
            <p className="mb-0">
              &copy; {new Date().getFullYear()} Fashion Flair World. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
